<template>
    <v-autocomplete
        :value="value"
        :items="items"
        :search-input.sync="query"
        :item-text="itemText"
        item-value="id"
        :label="label"
        :prepend-inner-icon="prependIcon"
        :rules="rules"
        :readonly="readonly"
        :clearable="!readonly"
        :loading="loading"
        :hint="readonly ? '' : hint"
        :persistent-hint="!readonly && !value"
        :no-data-text="query ? 'No matches' : 'Start typing to search'"
        return-object
        no-filter
        outlined
        @change="onChange"
    />
</template>

<script>
    // Autocomplete that searches the backend as you type instead of preloading every record
    export default {
        name: 'EntitySearch',
        props: {
            value: {
                type: Object,
                default: null
            },
            // (query: string) => Promise<Array<Object>>
            searchFn: {
                type: Function,
                required: true
            },
            itemText: {
                type: [String, Function],
                default: 'title'
            },
            label: {
                type: String,
                default: ''
            },
            hint: {
                type: String,
                default: 'Type to search'
            },
            prependIcon: {
                type: String,
                default: 'mdi-magnify'
            },
            rules: {
                type: Array,
                default: () => []
            },
            readonly: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                items: [],
                query: null,
                loading: false,
                debounceId: null,
                requestId: 0
            }
        },
        watch: {
            value: {
                immediate: true,
                handler(value) {
                    if (value && !this.items.some(item => item.id === value.id)) {
                        this.items = [value, ...this.items]
                    }
                }
            },
            query(query) {
                clearTimeout(this.debounceId)
                if (!query || (this.value && query === this.textOf(this.value))) {
                    return
                }
                this.debounceId = setTimeout(() => this.search(query), 350)
            }
        },
        beforeDestroy() {
            clearTimeout(this.debounceId)
        },
        methods: {
            textOf(item) {
                return typeof this.itemText === 'function' ? this.itemText(item) : item[this.itemText]
            },
            search(query) {
                const requestId = ++this.requestId
                this.loading = true
                this.searchFn(query).then(results => {
                    if (requestId !== this.requestId) {
                        return
                    }
                    const selected = this.value && !results.some(item => item.id === this.value.id) ? [this.value] : []
                    this.items = [...selected, ...results]
                }).catch(() => {
                    this.items = this.value ? [this.value] : []
                }).finally(() => {
                    if (requestId === this.requestId) {
                        this.loading = false
                    }
                })
            },
            onChange(item) {
                this.$emit('input', item || null)
            }
        }
    }
</script>
